import React, { useEffect, useState } from "react";
import "../assets/css/header.css";
import logo from "../assets/images/nexa-logo.png";
import { Outlet } from "react-router-dom";
import nav_logo from "../assets/images/lg_white.png";
import Navbar from "./Navbar";

const Header = () => {
  const [showNav, setShowNav] = useState(false);
  const [isScrolled, setIsScrolled] = useState("");
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled("bg-color");
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);

  return (
    <div className={`header-container`}>
      <div className={`header-content ${isScrolled ? isScrolled : ""}`}>
        <a href="/">
          <img
            className="logo"
            src={isScrolled ? logo : nav_logo}
            alt="logo dark"
          />
        </a>

        <Navbar
          showNav={showNav}
          setShowNav={setShowNav}
          isScrolled={isScrolled}
        />
        <div className="menu-bar" onClick={() => setShowNav(true)}>
          <span className={!isScrolled ? "bar-color" : "black"}></span>
          <span className={!isScrolled ? "bar-color" : "black"}></span>
          <span className={!isScrolled ? "bar-color" : "black"}></span>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Header;
